import { DatabaseTopology } from "./Operations/index.js";

export interface OrchestratorTopology extends DatabaseTopology {

}
